export default function LinkedinIcon({ className }) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M22.9724 0.505371H1.97157C1.00928 0.505371 0.227417 1.29817 0.227417 2.27139V23.234C0.227417 24.2072 1.00928 25 1.97157 25H22.9724C23.9347 25 24.722 24.2072 24.722 23.234V2.27139C24.722 1.29817 23.9347 0.505371 22.9724 0.505371V0.505371ZM7.63048 21.5008H4.00003V9.81114H7.63595V21.5008H7.63048ZM5.81525 8.21462C4.65067 8.21462 3.71025 7.26873 3.71025 6.10961C3.71025 4.95049 4.65067 4.0046 5.81525 4.0046C6.97438 4.0046 7.92026 4.95049 7.92026 6.10961C7.92026 7.2742 6.97984 8.21462 5.81525 8.21462V8.21462ZM21.2392 21.5008H17.6088V15.8145C17.6088 14.4586 17.5814 12.7144 15.7225 12.7144C13.8307 12.7144 13.5409 14.1907 13.5409 15.7161V21.5008H9.91045V9.81114H13.3933V11.4077H13.4425C13.9291 10.4891 15.1156 9.52136 16.8816 9.52136C20.5558 9.52136 21.2392 11.9435 21.2392 15.0928V21.5008Z" />
    </svg>
  );
}
